var _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdPgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3768 12.352C29.1813 11.6747 28.7651 11.0784 28.1917 10.6539C27.6183 10.2293 26.9189 9.99974 26.2 10H21.8C20.2893 10 19.0133 10.9951 18.6232 12.352M29.3768 12.352C29.4575 12.6306 29.5 12.9264 29.5 13.2308C29.5 13.5164 29.3841 13.7903 29.1778 13.9923C28.9715 14.1942 28.6917 14.3077 28.4 14.3077H19.6C19.3083 14.3077 19.0285 14.1942 18.8222 13.9923C18.6159 13.7903 18.5 13.5164 18.5 13.2308C18.5 12.9264 18.544 12.6306 18.6232 12.352M29.3768 12.352C30.3243 12.4224 31.2659 12.5099 32.2031 12.6162C33.8164 12.8 35 14.1627 35 15.7536V34.7692C35 35.6261 34.6523 36.4478 34.0335 37.0537C33.4146 37.6596 32.5752 38 31.7 38H16.3C15.4248 38 14.5854 37.6596 13.9665 37.0537C13.3477 36.4478 13 35.6261 13 34.7692V15.7536C13 14.1627 14.1821 12.8 15.7969 12.6162C16.7371 12.5096 17.6794 12.4215 18.6232 12.352",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0526 24.9336V22.049C25.0526 21.7708 24.9417 21.5039 24.7443 21.3072C24.5469 21.1105 24.2792 21 24 21C23.7208 21 23.4531 21.1105 23.2557 21.3072C23.0583 21.5039 22.9474 21.7708 22.9474 22.049V24.9336H20.0526C19.7735 24.9336 19.5057 25.0441 19.3083 25.2408C19.1109 25.4375 19 25.7043 19 25.9825C19 26.2607 19.1109 26.5275 19.3083 26.7242C19.5057 26.921 19.7735 27.0315 20.0526 27.0315H22.9474M25.0526 24.951H27.9474C28.2265 24.951 28.4943 25.0616 28.6917 25.2583C28.8891 25.455 29 25.7218 29 26C29 26.2782 28.8891 26.545 28.6917 26.7417C28.4943 26.9384 28.2265 27.049 27.9474 27.049H25.0526M25.0526 27.0664V29.951C25.0526 30.2292 24.9417 30.4961 24.7443 30.6928C24.5469 30.8895 24.2792 31 24 31C23.7208 31 23.4531 30.8895 23.2557 30.6928C23.0583 30.4961 22.9474 30.2292 22.9474 29.951V27.0664",
    stroke: "#8152E0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 26,
    r: 7.6,
    stroke: "#8152E0",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdPgReport);
export default __webpack_public_path__ + "static/media/sd-pg-report.d7924d9310d83170bdcc794972893f67.svg";
export { ForwardRef as ReactComponent };